import ApiService from '@/services/api.service'

const baseUrl = '/api/medications'

const MedicationService = {

	/**
	 * Retourne le médicament pour l'id donné
	 * @param {Number} id identifiant du médicament
	 */
	getMedication: async function(id) {
		
		const response = await ApiService.get(baseUrl + '/' + id)
		return response.data
	},

	/**
	 * Recherche les médicaments
	 */
	getMedications: async function() {

		const response = await ApiService.get(baseUrl)
		return response.data
	},

	/**
	 * Recherche les médicaments pour prescription
	 */
	getMedicationsForPrescription: async function() {

		const response = await ApiService.get(baseUrl + '/for-prescription')
		return response.data
	},

	/**
	 * Création d'un médicament ou mise à jour d'un médicament
	 * 
	 * @param {Object} médicament 
	 */
	saveMedication: async function(medication) {

		if (medication.id) {
			const response = await ApiService.post(baseUrl + '/'+ medication.id, medication)
			return response.data
		} else {
			const response = await ApiService.post(baseUrl, medication)
			return response.data
		}
	}
}

export default MedicationService